/**
 * Mini red lantern (viewBox 128×128) for festive coin flights and the lobby garland.
 * "Premium casual" like art/covers/kit.ts: soft volume (multi-stop gradients), light source top-left
 * (highlight top-left, shade bottom-right), soft shadow below, gold caps and tassel. No characters.
 * Theme-agnostic colours. `p` prefixes every <defs> id (many copies live on one page).
 */
export function lanternMarkup(p: string): string {
  return (
    `<defs>` +
    `<radialGradient id="${p}r" cx=".36" cy=".3" r=".8"><stop offset="0" stop-color="#FF9A8A"/>` +
    `<stop offset=".35" stop-color="#F0565B"/><stop offset=".75" stop-color="#C92F37"/><stop offset="1" stop-color="#8E1B24"/></radialGradient>` +
    `<linearGradient id="${p}g" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#FFE7A3"/>` +
    `<stop offset=".5" stop-color="#FFD166"/><stop offset="1" stop-color="#C8912A"/></linearGradient>` +
    `<radialGradient id="${p}s" cx=".5" cy=".5" r=".5"><stop offset="0" stop-color="#000" stop-opacity=".28"/>` +
    `<stop offset="1" stop-color="#000" stop-opacity="0"/></radialGradient>` +
    `</defs>` +
    `<ellipse cx="68" cy="112" rx="34" ry="7" fill="url(#${p}s)"/>` +
    `<path d="M64 4V20" stroke="url(#${p}g)" stroke-width="5" stroke-linecap="round"/>` +
    `<ellipse cx="64" cy="64" rx="45" ry="37" fill="url(#${p}r)"/>` +
    `<path d="M64 27Q38 64 64 101M64 27Q90 64 64 101M64 27Q52 64 64 101M64 27Q76 64 64 101" fill="none" stroke="#FFD166" stroke-opacity=".45" stroke-width="2.5"/>` +
    `<ellipse cx="46" cy="46" rx="14" ry="8" transform="rotate(-30 46 46)" fill="#FFFFFF" fill-opacity=".38"/>` +
    `<rect x="43" y="18" width="42" height="12" rx="5" fill="url(#${p}g)"/>` +
    `<rect x="43" y="98" width="42" height="12" rx="5" fill="url(#${p}g)"/>` +
    `<path d="M56 110V122M64 110V125M72 110V122" stroke="url(#${p}g)" stroke-width="3" stroke-linecap="round"/>`
  );
}
